import { render } from "./ContactSeller.vue?vue&type=template&id=049e0564"
import script from "./ContactSeller.vue?vue&type=script&lang=js"
export * from "./ContactSeller.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__